import get from 'lodash/get';

const SCORING_RECEIVE = 'SCORING_RECEIVE';

const reducer = (state = {}, action) => {
    /* eslint-disable no-case-declarations */
    switch (action.type) {
        case SCORING_RECEIVE:
            //console.log('action', action);
            const lastUpdated = get(state, `${action.endpointName}.lastUpdated`, '');
            const updateRequired = lastUpdated !== action.payload.lastUpdated;

            if (!state[action.endpointName] || updateRequired) {
                return {
                    ...state,
                    [action.endpointName]: action.payload
                };
            }
            return state;
        default:
            return state;
    }
};

export default reducer;

export const receiveScoring = (name, data) => ({
    type: SCORING_RECEIVE,
    endpointName: name,
    payload: data
});
